import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiIntegrationService {

  constructor(private http: HttpClient) { }

  private apiUrl = '';

  getApiList() {
    return this.http.get(`${this.apiUrl}/api-keys`);
  }

  getStampApiList() {
    return this.http.get(`${this.apiUrl}/estamp-bulk/api-keys`);
  }

  createApiKey(data: any, tab: string) {
    const endpoint = tab == 'esign' ? `${this.apiUrl}/api-keys` : `${this.apiUrl}/estamp-bulk/api-keys`
    return this.http.post(endpoint, data);
  }

  revokeApiKey(id: any, tab: string) {
    const endpoint = tab == 'esign' ? `${this.apiUrl}/api-keys` : `${this.apiUrl}/estamp-bulk/api-keys`
    if (tab == 'esign') {
      return this.http.delete(`${endpoint}/${id}`);
    } else {
      return this.http.patch(`${endpoint}/${id}`, {});
    }
  }

  webHookUrl(webhookURL: any, customerId: string) {
    return this.http.patch(`${this.apiUrl}/admin/customers/${customerId}/webhook`, { webhookURL });
  }
}
